module.exports = __webpack_public_path__ + "static/application_for_account_opening_and_maintenance-50acee533a317f4a2cdca215ffd7099c.pdf";